// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Pom Dependency Analyzer Web
 * https://github.com/tomasbjerre/pom-dependency-analyzer-web
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as url from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from './base';

/**
 *
 * @export
 * @interface Artifact
 */
export interface Artifact {
  /**
   *
   * @type {string}
   * @memberof Artifact
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof Artifact
   */
  artifactId: string;
}

/**
 *
 * @export
 * @interface Dependency
 */
export interface Dependency {
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  artifactId: string;
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  version: string;
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  classifier?: string;
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof Dependency
   */
  scope: string;
}

/**
 *
 * @export
 * @interface Group
 */
export interface Group {
  /**
   *
   * @type {string}
   * @memberof Group
   */
  groupId: string;
}

/**
 *
 * @export
 * @interface Metadata
 */
export interface Metadata {
  /**
   *
   * @type {string}
   * @memberof Metadata
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof Metadata
   */
  value: string;
}

/**
 *
 * @export
 * @interface Version
 */
export interface Version {
  /**
   *
   * @type {string}
   * @memberof Version
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof Version
   */
  artifactId: string;
  /**
   *
   * @type {string}
   * @memberof Version
   */
  version: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function(
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Get list of artifacts
     * @param {string} groupId The groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getArtifacts(groupId: string, options: any = {}): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getArtifacts.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts.json`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId)),
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of dependencies
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependencies(
      groupId: string,
      artifactId: string,
      version: string,
      options: any = {},
    ): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getDependencies.',
        );
      }
      // verify required parameter 'artifactId' is not null or undefined
      if (artifactId === null || artifactId === undefined) {
        throw new RequiredError(
          'artifactId',
          'Required parameter artifactId was null or undefined when calling getDependencies.',
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getDependencies.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts/{artifactId}/versions/{version}/dependencies.json`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'artifactId'}}`, encodeURIComponent(String(artifactId)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of dependents
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependents(
      groupId: string,
      artifactId: string,
      version: string,
      options: any = {},
    ): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getDependents.',
        );
      }
      // verify required parameter 'artifactId' is not null or undefined
      if (artifactId === null || artifactId === undefined) {
        throw new RequiredError(
          'artifactId',
          'Required parameter artifactId was null or undefined when calling getDependents.',
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getDependents.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts/{artifactId}/versions/{version}/dependents.json`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'artifactId'}}`, encodeURIComponent(String(artifactId)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get global metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlobalMetadata(options: any = {}): RequestArgs {
      const localVarPath = `/pdaw/metadata.json`;
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupIds(options: any = {}): RequestArgs {
      const localVarPath = `/pdaw/groups.json`;
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get version metadata
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetadata(
      groupId: string,
      artifactId: string,
      version: string,
      options: any = {},
    ): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getMetadata.',
        );
      }
      // verify required parameter 'artifactId' is not null or undefined
      if (artifactId === null || artifactId === undefined) {
        throw new RequiredError(
          'artifactId',
          'Required parameter artifactId was null or undefined when calling getMetadata.',
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getMetadata.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts/{artifactId}/versions/{version}/metadata.json`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'artifactId'}}`, encodeURIComponent(String(artifactId)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get version parsed
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParsed(
      groupId: string,
      artifactId: string,
      version: string,
      options: any = {},
    ): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getParsed.',
        );
      }
      // verify required parameter 'artifactId' is not null or undefined
      if (artifactId === null || artifactId === undefined) {
        throw new RequiredError(
          'artifactId',
          'Required parameter artifactId was null or undefined when calling getParsed.',
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getParsed.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts/{artifactId}/versions/{version}/parsed.json`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'artifactId'}}`, encodeURIComponent(String(artifactId)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get list of versions
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVersions(
      groupId: string,
      artifactId: string,
      options: any = {},
    ): RequestArgs {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getVersions.',
        );
      }
      // verify required parameter 'artifactId' is not null or undefined
      if (artifactId === null || artifactId === undefined) {
        throw new RequiredError(
          'artifactId',
          'Required parameter artifactId was null or undefined when calling getVersions.',
        );
      }
      const localVarPath = `/pdaw/groups/{groupId}/artifacts/{artifactId}/versions.json`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'artifactId'}}`, encodeURIComponent(String(artifactId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...options.headers,
      };

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get list of artifacts
     * @param {string} groupId The groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getArtifacts(
      groupId: string,
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Artifact>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getArtifacts(groupId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get list of dependencies
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependencies(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Dependency>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getDependencies(groupId, artifactId, version, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get list of dependents
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependents(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Dependency>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getDependents(groupId, artifactId, version, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get global metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlobalMetadata(
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<{ [key: string]: string }> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getGlobalMetadata(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get list of groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupIds(
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Group>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getGroupIds(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get version metadata
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetadata(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Metadata>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getMetadata(groupId, artifactId, version, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get version parsed
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParsed(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dependency> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getParsed(groupId, artifactId, version, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get list of versions
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVersions(
      groupId: string,
      artifactId: string,
      options?: any,
    ): (
      axios?: AxiosInstance,
      basePath?: string,
    ) => AxiosPromise<Array<Version>> {
      const localVarAxiosArgs = DefaultApiAxiosParamCreator(
        configuration,
      ).getVersions(groupId, artifactId, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH,
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @summary Get list of artifacts
     * @param {string} groupId The groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getArtifacts(groupId: string, options?: any) {
      return DefaultApiFp(configuration).getArtifacts(groupId, options)(
        axios,
        basePath,
      );
    },
    /**
     *
     * @summary Get list of dependencies
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependencies(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ) {
      return DefaultApiFp(configuration).getDependencies(
        groupId,
        artifactId,
        version,
        options,
      )(axios, basePath);
    },
    /**
     *
     * @summary Get list of dependents
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDependents(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ) {
      return DefaultApiFp(configuration).getDependents(
        groupId,
        artifactId,
        version,
        options,
      )(axios, basePath);
    },
    /**
     *
     * @summary Get global metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlobalMetadata(options?: any) {
      return DefaultApiFp(configuration).getGlobalMetadata(options)(
        axios,
        basePath,
      );
    },
    /**
     *
     * @summary Get list of groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupIds(options?: any) {
      return DefaultApiFp(configuration).getGroupIds(options)(axios, basePath);
    },
    /**
     *
     * @summary Get version metadata
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetadata(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ) {
      return DefaultApiFp(configuration).getMetadata(
        groupId,
        artifactId,
        version,
        options,
      )(axios, basePath);
    },
    /**
     *
     * @summary Get version parsed
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {string} version The version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParsed(
      groupId: string,
      artifactId: string,
      version: string,
      options?: any,
    ) {
      return DefaultApiFp(configuration).getParsed(
        groupId,
        artifactId,
        version,
        options,
      )(axios, basePath);
    },
    /**
     *
     * @summary Get list of versions
     * @param {string} groupId The groupId
     * @param {string} artifactId The artifactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVersions(groupId: string, artifactId: string, options?: any) {
      return DefaultApiFp(configuration).getVersions(
        groupId,
        artifactId,
        options,
      )(axios, basePath);
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Get list of artifacts
   * @param {string} groupId The groupId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getArtifacts(groupId: string, options?: any) {
    return DefaultApiFp(this.configuration).getArtifacts(groupId, options)(
      this.axios,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get list of dependencies
   * @param {string} groupId The groupId
   * @param {string} artifactId The artifactId
   * @param {string} version The version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDependencies(
    groupId: string,
    artifactId: string,
    version: string,
    options?: any,
  ) {
    return DefaultApiFp(this.configuration).getDependencies(
      groupId,
      artifactId,
      version,
      options,
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get list of dependents
   * @param {string} groupId The groupId
   * @param {string} artifactId The artifactId
   * @param {string} version The version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDependents(
    groupId: string,
    artifactId: string,
    version: string,
    options?: any,
  ) {
    return DefaultApiFp(this.configuration).getDependents(
      groupId,
      artifactId,
      version,
      options,
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get global metadata
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getGlobalMetadata(options?: any) {
    return DefaultApiFp(this.configuration).getGlobalMetadata(options)(
      this.axios,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get list of groups
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getGroupIds(options?: any) {
    return DefaultApiFp(this.configuration).getGroupIds(options)(
      this.axios,
      this.basePath,
    );
  }

  /**
   *
   * @summary Get version metadata
   * @param {string} groupId The groupId
   * @param {string} artifactId The artifactId
   * @param {string} version The version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getMetadata(
    groupId: string,
    artifactId: string,
    version: string,
    options?: any,
  ) {
    return DefaultApiFp(this.configuration).getMetadata(
      groupId,
      artifactId,
      version,
      options,
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get version parsed
   * @param {string} groupId The groupId
   * @param {string} artifactId The artifactId
   * @param {string} version The version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getParsed(
    groupId: string,
    artifactId: string,
    version: string,
    options?: any,
  ) {
    return DefaultApiFp(this.configuration).getParsed(
      groupId,
      artifactId,
      version,
      options,
    )(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get list of versions
   * @param {string} groupId The groupId
   * @param {string} artifactId The artifactId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getVersions(groupId: string, artifactId: string, options?: any) {
    return DefaultApiFp(this.configuration).getVersions(
      groupId,
      artifactId,
      options,
    )(this.axios, this.basePath);
  }
}
